import { App } from 'vue';
import NavigationTree from '@/project/search/navigation/NavigationTree.vue';

export default function navigationComponentRegistration(app: App): void {
    app.component('NavigationTree', NavigationTree);
}
